export default __webpack_public_path__ + "assets/flinker-icon-black.png";